(function(){
    "use strict";
    
    angular
        .module("app")
        .component("productSearchResults", { // product-search-results
            templateUrl: "src/app/productSearch/productSearchResults.html",
            controller: controller
        });

    function controller(session, CART_TYPE_CODE) {
        const $ctrl = this;
        $ctrl.session = session;
        $ctrl.searchCriteria = $ctrl.session.products.searchCriteria;
        $ctrl.classification = null;
        $ctrl.CART_TYPE_CODE = CART_TYPE_CODE;

        $ctrl.classification = getClassification();

        $ctrl.searchResultItemClass = product => {
            if (product.is_schedule_drug)
                return "search-result-item-schedule-drug";
            return "";
        };

        $ctrl.itemFilter = (value, index, array) => {
            //$ctrl.session.products.searchCriteria.searchText
            if ($ctrl.session.products.searchCriteria.cs && !value.is_schedule_drug)
                return false;

            if ($ctrl.session.products.searchCriteria.classId != null) {
                const classification = session.classifications.find(c => c.class_id === $ctrl.session.products.searchCriteria.classId);
                if (!classification)
                    return false;

                const found = classification.item_ids.find(i => i === value.item_id);
                if (!found)
                    return false;

                //if (!classification.item_ids.includes(value.item_id))
                //    return false;
            }

            return true;
        };

        $ctrl.searchingText = () => {
            if ($ctrl.session.products.searchCriteria.cs)
                return "Controlled Substances";
            
            if ($ctrl.session.products.searchCriteria.classId != null) {
                const classification = session.classifications.find(c => c.class_id === $ctrl.session.products.searchCriteria.classId);
                return `${classification.class_name}`;
            }
            
            return "All Products";
        };


        function getClassification() {
            if ($ctrl.session.products.searchCriteria.classId != null)
                return session.classifications.find(c => c.class_id === $ctrl.session.products.searchCriteria.classId);

            return null;
        };
    }
    controller.$inject = ["sessionService", "CART_TYPE_CODE"];
    
})()